import { useEffect, useState } from 'react';
import { getActiveFloatPlan } from '../../services/log-trips/float-plan';
import { useAppDispatch } from '../../services/store';
import { reset, setFloatPlan } from '../../services/store/modules/float-plan';
import {
  setPlanHasDiving,
  setPlanIsLoggingOn,
} from '../../services/store/modules/plan';

const useActiveFloatPlan = () => {
  const dispatch = useAppDispatch();
  const [activeFloatPlanId, setActiveFloatPlanId] = useState();

  useEffect(() => {
    const getData = async () => {
      dispatch(reset());
      const response = await getActiveFloatPlan();

      if (response) {
        dispatch(setFloatPlan(response));
        dispatch(setPlanIsLoggingOn(response.loloEnabled));
        dispatch(setPlanHasDiving(response.isDiving));
        setActiveFloatPlanId(response.id);
      }
    };
    getData();
  }, [dispatch]);

  return { activeFloatPlanId };
};

export default useActiveFloatPlan;
